export default "__VITE_ASSET__BT2r1HkC__"